(function() {
    'use strict';

    AgreementsPrivacyPracticesController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsPrivacyPracticesController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.moveTo = moveTo;
        vm.isSaving = false;
        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

        function moveTo(id) {
            document.getElementById(id).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }

        vm.disabledParentSigned = function() {
            return vm.agreement.conservatorSigned === true;
        }

        vm.disabledConservatorSigned = function() {
			return vm.agreement.parentSigned === true;
		}
    }

    angular.module('ipmApp').component('agreementsPrivacyPractices', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-privacy-practices/agreements-privacy-practices.html',
        controller: AgreementsPrivacyPracticesController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
